<template>
  <McButton
    variant="secondary"
    class="ms-2"
    size="small"
    icon="icon-outline_volume-up"
    text="Tes Audio"
    @click="playAudio"
  />
</template>

<script>
import McButton from '@/components/McButton'

export default {
  name: 'TableAudioPlayer',
  components: {
    McButton,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    playAudio() {
      this.$root.$emit('play-audio-request', this.item)
    },
  },
}
</script>
